import React from "react";

export default function Footer() {
  return (
    <footer className="dashboard-footer">
      <div className="footer-content">
        <span>
          © {new Date().getFullYear()} All Rights Reserved.
        </span>

        <span>
          Powered by LearnInsight
        </span>
      </div>
    </footer>
  );
}